import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, take, throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserActionTrackerService {
  constructor(private http: HttpClient) {}

  /**
   * Register the action
   * @param payload TrackUserAction
   * @returns Observable
   */
  registerAction(payload: Record<string, any>) {
    this.http
      .post('/api/usage/actions', payload)
      .pipe(
        take(1),
        catchError(error => throwError(() => error.error))
      )
      .subscribe();
  }
}
